(function () {
  document.documentElement.classList.add('gcmf2-js');

  function revealVisible() {
    var items = document.querySelectorAll('.gcmf2-reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (item) { observer.observe(item); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealVisible);
  } else {
    revealVisible();
  }
}());
